import React, {useState} from 'react'
import LeftMenu from './LeftMenu'
import Clickable from './Clickable'
import * as gtag from '../lib/gtag'
import { AiOutlinePhone } from '@react-icons/all-files/ai/AiOutlinePhone'
import Collapsible from './Collapsible'
import Input from './Input';
import { packagesSetFilters } from '../store/slices/entities/packages'
import { useDispatch, useSelector } from 'react-redux'


const PackageFilters = ({packages,  filters, allPackages,  prices, setPrices, rec, setRec, type, setType }) => {
    let dispatch = useDispatch()


    let clearFilters = () => {
        setPrices({})
        dispatch(packagesSetFilters({ min: 0, max: 10000 }))
      }
      console.log(rec)

    let updateFilters = (name, value) => {
        if (name.includes('p.')) {
          let [p, min, max] = name.split('.')

          setPrices({ [name]: value })
          if (!Object.values({ ...prices, [name]: value }).some(v => v)) dispatch(packagesSetFilters({ min: 0, max: 99999 }))
          else dispatch(packagesSetFilters({ min, max, prices: { [name]: value } }))

        }  else  if (name[0] === 'r') {
            let [r, rmin, rmax] = name.split('.')

            setRec({ [name]: value })
            if (!Object.values({ ...rec, [name]: value }).some(v => v)) dispatch(packagesSetFilters({ rmin: 0, rmax: 99999 }))
            else dispatch(packagesSetFilters({ rmin, rmax}))

          }  else  {
            setType({...type, [name]: value})
            dispatch(packagesSetFilters({ [name]: value}))

        }

      }

  return         <LeftMenu  className='packageCats' name='Package Filters' button={`View ${packages.length} Results`}>
  <div className="assistance">
          <a className='bookAss' href="tel:+13059744411" onClick={() => gtag.event({ action:  'booking_assistance_call', label: 'leads', value: 15, category: 'orders' })}> Booking Assistance <AiOutlinePhone /></a>
          <p>Do you need assistance with your booking or have any questions about the process? Give us a call <a href="tel:+13059744411" onClick={() => gtag.event({ action:  'booking_assistance_call', label: 'leads', value: 15, category: 'orders' })}>305 974 4411</a> or send us an email       <a href="mailto:info@miamisoundrental.com" onClick={() => gtag.event({ action: 'review_email', label: 'leads', value: 15, category: 'orders' })} >info@miamisoundrental.com</a></p>
      </div>
  <div className="clearFilters">
  <Clickable onClick={clearFilters} >Clear Filters</Clickable>
</div>
  <Collapsible name='Categories'  >
  <Input className='field-check-rev' value={filters.wedding} type='checkbox' name='wedding' label='Weddings' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={filters.corporate} type='checkbox' name='corporate' label='Corporate' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={filters.celebration} type='checkbox' name='celebration' label='Private Celebration' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={filters.concert} type='checkbox' name='concert' label='Concert' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={filters.trade} type='checkbox' name='trade' label='Trade Show' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  {allPackages.some(p => p.package_type === 'private') && <Input className='field-check-rev' value={filters.private} type='checkbox' name='private' label='My Packages' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />}

  </Collapsible  >
  <Collapsible name='Price'  >
  <Input className='field-check-rev' value={prices?.['p.0.500']} type='checkbox' name='p.0.500' label='Under $500' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={prices?.['p.500.999']} type='checkbox' name='p.500.999' label='$500 - $999' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={prices?.['p.1000.1999']} type='checkbox' name='p.1000.1999' label='$1000 - $1999' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={prices?.['p.2000.2999']} type='checkbox' name='p.2000.2999' label='$2000 - $2999' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={prices?.['p.3000.99999']} type='checkbox' name='p.3000.99999' label='More than $3000' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  </Collapsible  >
  <Collapsible name='Use'  >
  <Input className='field-check-rev' value={type?.dj} type='checkbox' name='dj' label='DJ' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={type?.band} type='checkbox' name='band' label='Band' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={type?.musician} type='checkbox' name='musician' label='Musician' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={type?.mics} type='checkbox' name='mics' label='Microphones / Speeches' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={type?.visual} type='checkbox' name='visual' label='Presentations / Visuals' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  </Collapsible  >

  <Collapsible name='Recommended For'  >
  <Input className='field-check-rev' value={rec?.['r.0.100']} type='checkbox' name='r.0.100' label='Less than 100 people' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={rec?.['r.100.199']} type='checkbox' name='r.100.199' label='100 - 199 people' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={rec?.['r.200.499']} type='checkbox' name='r.200.499' label='200 - 499 people' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={rec?.['r.500.999']} type='checkbox' name='r.500.999' label='500 - 999 people' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  <Input className='field-check-rev' value={rec?.['r.1000.99999']} type='checkbox' name='r.1000.99999' label='1000+ people' onChange={(e) => updateFilters(e.target.name, e.target.checked)} />
  </Collapsible  >


</LeftMenu>
}

export default PackageFilters
